import styled from "styled-components";
import { media } from "./breakpoints";
import { brandmedium, neutral10 } from "../css/colors";
import { primaryFontFamilyBold } from "./fontFamilyTypes";
export const Container78VW = styled.section `
  width: 100vw;
  max-width: 78vw;
  margin: 0px auto;

  @media ${media.large.down} {
    max-width: 90vw;
  }
`;
export const GradientContainer = styled.div `
  background: radial-gradient(35% 25% at top, #474e57, ${brandmedium});
`;
export const GroupTitle = styled.div `
  font-family: ${primaryFontFamilyBold};
  font-size: 32px;
  color: ${neutral10};
  text-align: center;
  padding: 35px 0px;
  max-width: 50vw;
  line-height: 1.37;
  @media ${media.medium.down} {
    font-size: 18px;
  }
  @media ${media.xsmall.down} {
    max-width: 100vw;
    padding: 16px 54px;
  }
`;
export const AlignCenter = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;

